import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thank-you-div',
  templateUrl: './app.thankyoucomponent.html',
  styleUrls: ['./app.thankyoucomponent.css']
})
export class ThankYouComponent implements OnInit {
  phone: string;
  ngOnInit() {}
}
